<template>
  <v-app-bar app color="#ffffff" flat height="60" class="mainHeaderBar">
    <div class="d-flex align-center main-header">
      <div class="mainHeaderBar__logo">
        <v-img
          alt="TaskDash Logo"
          contain
          :src="require('../assets/logo.png')"
          transition="scale-transition"
          width="76"
        />
      </div>
    </div>
    <v-spacer />
    <!-- Admins: globale Order-Suche · Zeichner: Earnings (Alt-Logik) -->
    <HeaderOrderSearch v-if="canSearchOrders" />
    <!-- Admins: Import-Anteile je Nutzer (Farbleiste, Hover = Name + Anzahl) -->
    <HeaderImports v-if="isAdmin" />
    <CurrentEarnings v-if="!isAdmin" />
    <v-spacer />
    <!-- Generieren im Dialog (statt Menüpunkt): Admins und MANAGER, wie die Route /generate -->
    <HeaderGenerate v-if="canGenerate" />
    <!-- Laufende/fertige Bild-Edits (upscaleJobs lesbar für ADMIN/TASK_IMPORTING) -->
    <HeaderEdits v-if="canSeeEdits" />
    <!-- Team-Checkliste: Admins, Order-Manager und MANAGER -->
    <HeaderChecklist v-if="canSeeChecklist" />
    <MainAccount />
  </v-app-bar>
</template>

<script>
import { mapGetters } from "vuex";
import MainAccount from "@/components/MainAccount";
import CurrentEarnings from "@/components/CurrentEarnings";
import HeaderOrderSearch from "@/components/HeaderOrderSearch";
import HeaderChecklist from "@/components/HeaderChecklist";
import HeaderGenerate from "@/components/HeaderGenerate";
import HeaderEdits from "@/components/HeaderEdits";
import HeaderImports from "@/components/HeaderImports";
import { permissions } from "@/constants";

export default {
  name: "MainHeader",
  components: { HeaderGenerate, HeaderEdits, HeaderImports, HeaderChecklist, HeaderOrderSearch, CurrentEarnings, MainAccount },
  computed: {
    ...mapGetters(["userPermissions"]),
    isAdmin() {
      return this.userPermissions.includes(permissions.ADMIN);
    },
    canSearchOrders() {
      return (
        this.isAdmin || this.userPermissions.includes(permissions.MANAGE_ORDERS)
      );
    },
    canSeeChecklist() {
      return this.canSearchOrders || this.userPermissions.includes(permissions.MANAGER);
    },
    canSeeEdits() {
      return this.isAdmin || this.userPermissions.includes(permissions.TASK_IMPORTING);
    },
    canGenerate() {
      return this.isAdmin || this.userPermissions.includes(permissions.MANAGER);
    },
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
.main-header {
  z-index: 999;
}

.mainHeaderBar {
  box-shadow: 0 1px 2px rgba(16, 24, 40, 0.06), 0 4px 14px rgba(16, 24, 40, 0.07) !important;

  /* Logo stammt aus der dunklen Ära — dunkle Pill hält es lesbar */
  &__logo {
    //background: #282828;
    //border-radius: 12px;
    //padding: 6px 14px;
    display: flex;
    align-items: center;
  }
}
</style>
